import { createFeatureSelector, createSelector } from "@ngrx/store";
import { cardDetailResModel } from "../models/cardBalanceResponse.model";
import { userFavoritesResModel, virtualCardsResModel } from "./models/storage-model";
import * as fromHome from './reducers';

export const selectHomeState =  createFeatureSelector<fromHome.HomeState>("home");

export const selectFavoritesState = createSelector(
    selectHomeState,
    state => state.favorites
);

export const selectFavorites = createSelector(
    selectFavoritesState,
    fromHome.selectAllFavorites
);

export const isFavoritesLoaded = createSelector(
    selectFavoritesState,
    state => state.loadedFavorites
);

export const selectCardsState = createSelector(
    selectHomeState,
    state => state.cards
);

export const selectCards = createSelector(
    selectCardsState,
    fromHome.selectAllCards
);

export const isCardsLoaded = createSelector(
    selectCardsState,
    state => state.loadedCards
);

export const selectCardBalanceState = createSelector(
    selectHomeState,
    state => state.balances
);

export const selectAllCardBalances = createSelector(
    selectCardBalanceState,
    fromHome.selectAllCardBalances,
);

export const selectCardBalance = (alias:string) => createSelector(
    selectAllCardBalances,
    (a:cardDetailResModel[]) => {
        return a.find((entity:cardDetailResModel) => entity.aliasNo == alias)
    }
)

export const isSelectCardBalance = (alias:string) => createSelector(
    selectAllCardBalances,
    (a:cardDetailResModel[]) => {
        return !!a.find((entity:cardDetailResModel) => entity.aliasNo == alias)
    }
)